// monkeypatch-useState.js
import * as React from "react";

const originalUseState = React.useState;

const callCount = {}


React.useState = function patchedUseState(initialValue) {
  const [state, setState] = originalUseState(initialValue);

  

  function patchedSetState(value) {
    const err = new Error();
    const stack = err.stack
      .split("\n")
      //.slice(2) // skip Error + this function
      .join("\n");

    console.groupCollapsed("[useState] setter called");
    console.log("Previous state:", state);
    console.log("Next (arg):", value);
    console.log("Call stack:\n", stack);
    console.groupEnd();

    console.log("Call stack:\n", stack);

    callCount[stack] = (callCount[stack]||0)+1

    if( window.shouldDebugStateChanges ){
      debugger;
    }
    console.log("Something is happening!");
    return setState(value);
  }

  return [state, patchedSetState];
};
